import { DeleteNpsSurveyArgs } from 'types/api/arguments/delete-nps-survey-args'

import { api } from './api'

export const deleteNpsSurvey = ({ userId }: DeleteNpsSurveyArgs) =>
  api.delete(`/users/${userId}/nps`)
